import $ from 'jquery'
import { clickLinkEvent } from 'application/ga_click_link_event'
import { viewModalEvent } from 'application/ga_view_modal_event'
import { clickToggleEvent } from 'application/ga_click_toggle_event'
import { closeModalEvent } from 'application/ga_close_modal_event'
import { trim, snakeCase } from 'lodash'

SOPHIA.clickedPopupLink = function (boolean = false) {
  return boolean
}

SOPHIA.clickLinkForGA = function ($mainContainer, options) {
  $("a, [data-open-modal], [data-open]", $mainContainer).off('click.link').on('click.link', (e) => {
    let $clickedLink,
        moduleName,
        linkType,
        linkHref = null,
        $this = $(e.target);

    $clickedLink = $this.closest('a').length ? $this.closest('a') : $this.closest('[data-open-modal]');

    const linkURL = $clickedLink.attr('href'),
          JSLink = linkURL == 'javascript:void(0);' || linkURL == 'javascript:void(0)' || $clickedLink.attr('href') == '#',
          isLink = $clickedLink.closest("a").length,
          signInLink = $clickedLink.hasClass('w-flexible-header__anonym-sign-in');

    if (!linkURL || linkURL.startsWith("/") || linkURL.startsWith("?") || linkURL.includes(location.hostname)) {
      linkType = "internal link"
    } else if (linkURL.startsWith("#")) {
      linkType = "anchor link"
    } else if (!JSLink) {
      linkType = "external link"
    }

    if (options && options.moduleName) {
      moduleName = options.moduleName
    } else if ($clickedLink.data('moduleName')) {
      moduleName = $clickedLink.data('moduleName')
    } else if ($clickedLink.parents('.w-flexible-header').length) {
      moduleName = 'header'
    } else if ($clickedLink.parents('.w-flexible-footer').length) {
      moduleName = 'footer'
    } else if ($clickedLink.hasClass('flexible-sticky-nav-item')) { // sticky navigation
      moduleName = 'navigation'
      linkHref = '#' + $clickedLink.data('id')
      linkType = 'anchor link'
    } else {
      moduleName = 'body'
    }

    if (($clickedLink.parents('.flexible-sticky-nav').length || !JSLink) && isLink && !signInLink) { // sticky navigation and sign in link are an exception
      const gaDataClickLink = {
        module_name: moduleName,
        click_text: $clickedLink.data('kmValue') || trim($clickedLink.text()),
        link_url: linkHref || $clickedLink.attr('href'),
        link_type: linkType
      }

      // GA Click Link Event
      clickLinkEvent(gaDataClickLink)
    }

    if ($clickedLink.is('[data-open-modal]') || $clickedLink.is('[data-open]') ) { // should be the last
      const gaDataViewModal = {
        module_name: moduleName,
        click_text: $clickedLink.data('kmValue') || trim($clickedLink.text())
      }

      // GA View Modal Event
      viewModalEvent(gaDataViewModal, true)
    }
  })
}

SOPHIA.clickModalCloseForGA = function (target, container) {
  let $this = $(target),
      $container = container ? $(container) : $this.closest('.fancybox-content'),
      $caption = $(":header:first", $container),
      gaDataCloseModal,
      moduleName;

  const isSpinnerPopup = $container.is('.fancybox-loading'),
        isFlexiblePage = $('body.flexible-layout:not(.touchstone-grading-page)').length,
        isXButton = $this.is('[data-fancybox-close]') || $this.is('[data-close]')

  if ($container.is('.basicConfirm')) {
    moduleName = "confirmation_modal"
  } else if ($container.is('.modal-message')) {
    moduleName = "modal_message"
  } else {
    moduleName = $caption.text() || $container.attr('id') || $("meta[property='og:title']").attr("content")
  }

  if (!isSpinnerPopup && isFlexiblePage && $container.length) {
    gaDataCloseModal = {
      module_name: snakeCase(moduleName),
      click_text: isXButton ? 'X' : trim($this.text() || $this.val())
    }

    closeModalEvent(gaDataCloseModal, target ? true : false)
  }
}

$(document).ready(() => {
  SOPHIA.clickLinkForGA($('body.flexible-layout:not(.touchstone-grading-page)'));
})

SOPHIA.clickToggleForGA = function (options) {
  let moduleName = options.moduleName || ''
  const $toggleElement = $(options.el)

  if ($toggleElement.parents('.w-flexible-header').length) {
    moduleName = 'header'
  } else if ($toggleElement.parents('.w-flexible-footer').length) {
    moduleName = 'footer'
  }

  const gaDataClickToggle = {
    module_name: moduleName,
    click_text: options.clickText || trim($toggleElement.text()),
    field_type: options.fieldType,
    event_action: options.eventAction
  }

  // GA Click Toggle Event
  clickToggleEvent(gaDataClickToggle)
}
